import $ from 'jquery';
import videoComponent from '../video/videoComponent';

const videoPlayer = {
    variables: {
        videoPlayerContainer : ".video-player--container",
        videoElement : ".video-player--element",
    },
    methods: {
        chacheSelectors: function() {
            const v = videoPlayer.variables;
            videoPlayer.elements = {
                $videoPlayerContainer: $(v.videoPlayer),
            };
        },
        
        init: function() {
           videoComponent.methods.registerVideo(videoPlayer.variables.videoElement);
        },
    },
};

if ($(videoPlayer.variables.videoPlayerContainer).length > 0) {
    videoPlayer.methods.init();
}
